import {
  ChartMark,
  WidgetKind,
  type Filters,
  type Report,
} from 'corso-admin-ui';
import { CrewClaimStatusCode } from 'corso-types';
import { byFinalizedDay, topProducts } from '../claimItems';

const approved = {
  claimStatuses: [CrewClaimStatusCode.approved],
} satisfies Filters<'claimItems'>;

export const overview = {
  key: 'overview',
  label: 'Overview',
  dataset: 'claimItems',
  timeFields: ['createdOn'],
  widgets: [
    {
      kind: WidgetKind.kpi,
      title: 'Products requested',
      metric: 'items',
    },
    {
      kind: WidgetKind.kpi,
      title: 'Products approved',
      metric: 'items',
      filters: approved,
    },
    {
      kind: WidgetKind.overTime,
      title: 'Product requests over time',
      mark: ChartMark.line,
      metrics: ['items'],
    },
    {
      kind: WidgetKind.overTime,
      title: 'Approved products over time',
      description: byFinalizedDay,
      mark: ChartMark.line,
      metrics: ['items'],
      filters: approved,
      timeField: 'finalizedOn',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Requests by status',
      dimension: 'status',
      metric: 'items',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Resolution status',
      dimension: 'claimStatus',
      metric: 'items',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Top approved reasons',
      dimension: 'reason',
      metric: 'items',
      filters: approved,
      limit: 10,
    },
    {
      ...topProducts,
      title: 'Top approved products',
      description: byFinalizedDay,
      filters: approved,
      timeField: 'finalizedOn',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Requests by product type',
      dimension: 'productType',
      metric: 'items',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Resolutions',
      dimension: 'resolution',
      metric: 'items',
    },
  ],
} as const satisfies Report;
